import { useConfigEditor, SaveBar, Field, TextArea, Section } from "../../lib/admin-shared";

export default function HeaderFooterEditor() {
    const { cfg, set, save, saving, saved, loading } = useConfigEditor();
    if (loading || !cfg) return <div className="text-muted-foreground">Loading…</div>;

    return (
        <div className="max-w-3xl space-y-8" data-testid="header-footer-editor">
            <div>
                <h1 className="font-display text-4xl mb-2">Header & Footer</h1>
                <p className="text-muted-foreground">Public navigation, footer copy, contact details, and social media links.</p>
            </div>

            <Section title="Footer copy">
                <TextArea label="Footer description" value={cfg.footer_text} onChange={(v) => set("footer_text", v)} rows={3} testid="hf-footer-text" />
            </Section>

            <Section title="Contact details" description="Shown in the footer and on the Contact page.">
                <div className="grid sm:grid-cols-3 gap-5">
                    <Field label="Contact email" value={cfg.contact_email} onChange={(v) => set("contact_email", v)} testid="hf-contact-email" />
                    <Field label="Contact phone" value={cfg.contact_phone} onChange={(v) => set("contact_phone", v)} testid="hf-contact-phone" />
                    <Field label="Office address" value={cfg.contact_address} onChange={(v) => set("contact_address", v)} testid="hf-contact-address" />
                </div>
            </Section>

            <Section title="Social media links" description="Empty fields hide the corresponding icon in the footer.">
                <div className="grid sm:grid-cols-2 gap-5">
                    <Field label="Facebook URL" value={cfg.social_facebook} onChange={(v) => set("social_facebook", v)} testid="hf-social-fb" />
                    <Field label="Twitter / X URL" value={cfg.social_twitter} onChange={(v) => set("social_twitter", v)} testid="hf-social-tw" />
                    <Field label="Instagram URL" value={cfg.social_instagram} onChange={(v) => set("social_instagram", v)} testid="hf-social-ig" />
                    <Field label="LinkedIn URL" value={cfg.social_linkedin} onChange={(v) => set("social_linkedin", v)} testid="hf-social-li" />
                    <Field label="YouTube URL" value={cfg.social_youtube} onChange={(v) => set("social_youtube", v)} testid="hf-social-yt" />
                </div>
            </Section>

            <SaveBar onSave={save} saving={saving} saved={saved} />
        </div>
    );
}
